import { Text, VStack } from '@chakra-ui/react';
import React from 'react';

import type { Transaction } from 'types/api/transaction';

import { AddressHighlightProvider } from 'lib/contexts/addressHighlight';
import { Button } from 'toolkit/chakra/button';
import { Link } from 'toolkit/chakra/link';

import LatestTxsItem from './LatestTxsItem';

interface Props {
  data?: Array<Transaction>;
  isPlaceholderData: boolean;
  isError: boolean;
  txsCount: number;
  txsUrl: string;
}

const LatestTransactions = ({ data, isPlaceholderData, isError, txsCount, txsUrl }: Props) => {

  if (isError) {
    return <Text mt={ 4 }>No data. Please reload the page.</Text>;
  }

  if (data) {
    return (
      <>
        <AddressHighlightProvider>
          <VStack mb={ 6 } gap="10px" overflow="scroll" alignItems="left">
            { data.slice(0, txsCount).map(((tx, index) => (
              <LatestTxsItem
                key={ tx.hash + (isPlaceholderData ? index : '') }
                tx={ tx }
                isLoading={ isPlaceholderData }
              />
            ))) }
          </VStack>
        </AddressHighlightProvider>
        <Button w="100%" variant="outline" size="lg">
          <Link variant="button" href={ txsUrl }>View all transactions</Link>
        </Button>
      </>
    );
  }

  return null;
};

export default LatestTransactions;
